cv.ProfileView = Marionette.LayoutView.extend({
  template : cv.Templates['profile/view'],

  behaviors : [{
    behaviorClass : cv.FormBehavior
  }],

	events : {
	},

	validation: {
    photo_path : [],
		first_name: [{
		    required: 'true',
		    msg: "Required"
		}],
		last_name: [{
		    required: 'true',
		    msg: "Required"
		}]
	},

	initialize: function(options){
		this.options = _.extend(this.options, options);
    this.model = cv.user;

    this.listenTo(this, 'form:saved', function(){
      vent.trigger('project:refresh');
    }, this);

		console.log('ProfileView initialized');
	},

  templateHelpers: function(){
    return {
      profile_photo_cropper: cv.Templates['global/form/form_upload_profile']({
        label : 'Profile Photo',
        id : 'photo_path',
        photo_default : cv.campaign.get('default_fundraiser_photo')
      })
    }
  }
});
